<template>
  <div class="steps-wrap">
    <div class="steps">
      <slot></slot>
    </div>
    <div class="steps-line">
      <p></p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ep-steps',
  data() {
    return {

    }
  }
} 
</script>

<style scoped>
.steps-wrap {
  width: 100%;
  height: auto;
  position: relative;
}

.steps {
  width: 100%;
  height: auto;
  position: relative;
  display: inline-flex;
}

.steps-line {
  height: 20px;
  width: 100%;
  box-sizing: border-box;
  border: 1px solid transparent;
  position: relative;
}

.steps-line p {
  width: 100%;
  background: #373d41;
  margin: 0;
  padding: 0;
  margin-top: 10px;
  height: 2px;
  position: relative;
}

</style>




// WEBPACK FOOTER //
// Steps.vue?32daaeaf